import { useEffect, useState } from "react"

import AddButton from "../ScenarioTypeEditor/AddButton"

import SearchEntity from "./SearchEntity"
import SelectEntity from "./SelectEntity"

const AssociateModel = ({ model, choices=[], search = false, addHandler}) => {
    const [id, setID] = useState("")
    const [errMsg, setErrMsg] = useState("")
    const [listName, setListName] = useState(null)

    const onAdd = (event) => {
        if ("" !== id) {
            addHandler(model.type, "", id)
            setID("")
            setErrMsg("")
        } else {
            setErrMsg(`Please make a selection.`)
        }
    }

    const changeHandler = (event) => setID(event.target.value)

    useEffect(
        () => {
            if (!listName) {
                setListName(`${model.type}-list`)
            }
        }, [model, listName]
    )

    return (
        <div className="add-entity">
            <table style={{width: "100%"}}>
                <tbody>
                    <tr>
                        <td> <b>Add {model.name}</b> </td>
                        <td>
                            {!!search
                             ? (
                                <SearchEntity
                                    listName={listName}
                                    currValue={id}
                                    choices={choices}
                                    changeHandler={changeHandler}
                                />
                             )
                             : (
                                <SelectEntity
                                    currValue={id}
                                    choices={choices}
                                    changeHandler={changeHandler}
                                />
                             )
                            }
                            <br/>
                            <span className="err-msg"> {errMsg} </span>
                        </td>
                        <td> <AddButton addHandler={onAdd}/> </td>
                    </tr>
                </tbody>
            </table>
        </div>
    )
}

export default AssociateModel